import { z } from "zod/v4";

import { ShippingRateDtoSchema } from "../dtos/shipping-rates";

export const ShippingRateFeSchema = ShippingRateDtoSchema.extend({
  amount: z.number().nullish(),
});

export type ShippingRateFe = z.infer<typeof ShippingRateFeSchema>;
